




































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  ProjectTaskEditModel,
  RateRuleAmountFilter,
  RateRuleAmountModel
} from '@/services/api/nswag/stapiclient_generated';
import { stProjectTaskApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import StRatePicker from '@/components/basic/StRatePicker.vue';
import {DialogResponse} from 'vue-tailwind/dist/components/TDialog';
import {notifySuccess} from '@/utlitities/notifications';

@Component({
  components: {
    StRatePicker,
  },
})
export default class ProjectProjectTaskEditList extends Vue {
  @Prop() projectId!: number;
  @Prop() customerId!: number;
  @Prop() value!: ProjectTaskEditModel[];
  @Prop() projectRuleAmount!: RateRuleAmountModel;
  @Prop() disabled!: boolean;
  @Prop() isFixedPrice!: boolean;

  projectTaskDelLoadingId = -1;

  async newItem() {
    this.editModels.push(await stProjectTaskApi.getNewWithProjectId(this.customerId, this.projectId));
  }

  get useRateRules() {
    return UserStore.userSettings.useRateRules;
  }

  getRateRuleAmountFilter(projectTaskId: number){
    return RateRuleAmountFilter.fromJS({
      customerId: this.customerId,
      projectId: this.projectId,
      projectTaskId: projectTaskId,
      appUserId: undefined,
    });
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  async remove(index: number) {
    try {
      let projectTaskId = this.editModels[index].id!;
      if(!projectTaskId){
        this.editModels.splice(index, 1);
        return
      }

      this.projectTaskDelLoadingId = projectTaskId;
      const result = await stProjectTaskApi.delete(projectTaskId, false, false);
      if (result.confirmationNeeded) {
        const res: DialogResponse = await this.$dialog.confirm({
          title: this.$t('Bestätigung').toString(),
          text: result.message,
          variant: 'danger',
          okButtonText: this.$t('Löschen').toString(),
          cancelButtonText: this.$t('Abbrechen').toString()
        });
        if (res.isOk) {
          this.editModels.splice(index, 1);
        }
      }else{
        this.editModels.splice(index, 1);
      }
    } finally {
      this.projectTaskDelLoadingId = -1;
    }
  }

  get editModels() {
    return this.value;
  }

  set editModels(data: ProjectTaskEditModel[]) {
    this.$emit('input', data);
  }
}
